export default __webpack_public_path__ + "static/media/dracula-the-return-issue-1.7b0952ee.jpg";